export default "__VITE_ASSET__4a2199b0__"